/**
 * vendor-prism.js — self-hosted Prism + the language components the app used
 * to pull individually from cdnjs (MPE-557).
 *
 * Import order matters: `prismjs` core must be evaluated first because it
 * assigns `window.Prism`, and every `components/prism-*.js` file mutates that
 * global (`Prism.languages.x = …`) rather than importing anything. esbuild
 * preserves import order, so core lands first.
 *
 * Language set matches the previous cdnjs <script> list exactly:
 *   javascript, python, java, sql, css, bash
 * (markup/css/clike/javascript also ship inside core; the redundant imports
 * are kept so the vocabulary stays explicit.)
 *
 * Auto-highlight-on-load behaviour is Prism's own and is unchanged.
 */
import Prism from 'prismjs';

import 'prismjs/components/prism-javascript.js';
import 'prismjs/components/prism-python.js';
import 'prismjs/components/prism-java.js';
import 'prismjs/components/prism-sql.js';
import 'prismjs/components/prism-css.js';
import 'prismjs/components/prism-bash.js';

window.Prism = Prism;
